module.exports = __webpack_public_path__ + "static/media/iconTickBlue.dd2bd9aa.svg";